import { Permissions } from '@app/core/models';

export const HOTEL_VIEW_PERMISSIONS = `(
     ${Permissions.Permission.CanAccessSchedulerAndAddEditShifts}
  || ${Permissions.Permission.CanAccessRealtimeHotelLaborAnalyzer}
  || ${Permissions.Permission.CanAccessDailyLaborCheckIn}
  || ${Permissions.Permission.CanAccessHotelRevenueAnalyzer}
  || ${Permissions.Permission.CanAccessAbsenceMonitor}
  || ${Permissions.Permission.CanAccessWellnessChecksAndReporting}
)`;

export const HOTEL_GROUPS_VIEW_PERMISSIONS = `(
     ${Permissions.Permission.CanAccessRealtimeHotelLaborAnalyzer}
  && ${Permissions.Permission.HasMoreThanOneHotel}
)`;

export const PERFECT_LABOR_PERMISSIONS = `(
     ${Permissions.Permission.CanAccessSchedulerAndAddEditShifts}
  || ${Permissions.Permission.CanAccessRealtimeHotelLaborAnalyzer}
  || ${Permissions.Permission.CanAccessDailyLaborCheckIn}
  || ${Permissions.Permission.CanAccessHotelRevenueAnalyzer}
)`;

export const HOTEL_GROUP_SUMMARY_REPORT_PERMISSIONS = `(
      ${Permissions.Permission.CanAccessRealtimeHotelLaborAnalyzer}
  &&  ${Permissions.Permission.HasMoreThanOneHotel}
  && !${Permissions.Permission.HasDepartmentFilters}
)`;
